// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-object-instance-block{
   height: 100%;
   overflow: auto;
   background-color: var(--sub-window-bg);
   border: var(--border);
   padding: var(--padding-sm);
   border-radius: var(--border-radius);
   
   .label-value-block label{
      padding-top: unset ;
      padding-bottom: unset;
      padding-right: var(--padding);
      padding-left: var(--padding);
      text-transform: capitalize;
   }

   .label-value-block p{
      padding-top: unset;
   }
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLObjectInstanceBlock/ECLObjectInstanceBlock.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,cAAc;GACd,sCAAsC;GACtC,qBAAqB;GACrB,0BAA0B;GAC1B,mCAAmC;;GAEnC;MACG,mBAAmB;MACnB,qBAAqB;MACrB,6BAA6B;MAC7B,4BAA4B;MAC5B,0BAA0B;GAC7B;;GAEA;MACG,kBAAkB;GACrB;AACH","sourcesContent":[".ecl-object-instance-block{\r\n   height: 100%;\r\n   overflow: auto;\r\n   background-color: var(--sub-window-bg);\r\n   border: var(--border);\r\n   padding: var(--padding-sm);\r\n   border-radius: var(--border-radius);\r\n   \r\n   .label-value-block label{\r\n      padding-top: unset ;\r\n      padding-bottom: unset;\r\n      padding-right: var(--padding);\r\n      padding-left: var(--padding);\r\n      text-transform: capitalize;\r\n   }\r\n\r\n   .label-value-block p{\r\n      padding-top: unset;\r\n   }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
